import { render, staticRenderFns } from "./CDPTag.vue?vue&type=template&id=09294c1f&scoped=true"
import script from "./CDPTag.vue?vue&type=script&lang=js"
export * from "./CDPTag.vue?vue&type=script&lang=js"
import style0 from "./CDPTag.vue?vue&type=style&index=0&id=09294c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09294c1f",
  null
  
)

export default component.exports